import axios from 'axios';

const normalizeBaseUrl = (value) => {
    if (!value) {
        return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
};

const getBaseURL = () => {
    const envBaseUrl = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);
    if (envBaseUrl) {
        return envBaseUrl;
    }

    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://127.0.0.1:5000/';
    }

    return '/api/';
};

export const BASE_URL = getBaseURL();

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    timeout: 60000,
});

export default axiosInstance;
